import React, { Component } from "react";
import { connect } from "react-redux";
import {
  getFundsByPan,
  getTransactionHistory,
  RemoveTransactionData,
} from "../../../store/actions";

import { Paper } from "@material-ui/core";

import { Debtbutton } from "../../forms/button";
import { NEW_TRANSACTION_URL } from "../transactions";
import { FormatCurrency } from "../../home/currencyFormatter";

import CustomLoader from "../../forms/Loader";
import Image from "../../Image";

class HistoryDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      transactionList: [],
      showError: false,
      display: false,
      errorText: "",
    };
  }

  componentDidMount() {
    const { state } = this.props.location;
    const { isKyc } = state;
    if (!!isKyc) {
      this.getFunds();
    } else {
      this.setState({ showError: true });
    }
  }

  getFunds = async () => {
    this.props.RemoveTransactionData();
    this.getTransactions("189");
  };

  getTransactions = async (fund) => {
    this.setState({ selectedFund: "189", display: true });
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    const { investorData, userId } = this.props;
    const params = {
      Uid: userId,
      pan: investorData.PAN,
      InvdDistFlag: "A",
      Fund: fund,
    };
    const response = await this.props.getTransactionHistory(params);
    if (!response) {
      this.setState({
        errorText: "No Data Found",
      });
    }
    this.setState({
      display: false,
    });
  };

  render() {
    const { state } = this.props.location;
    const { isKyc } = state;
    const { showError, selectedFund, display } = this.state;
    const { fundsList, transactions, investorData } = this.props;

    return (
      <>
        <Paper
          className="digital-form-container"
          style={{
            boxShadow: "0px 0px 2px 0px lightgray",
            marginTop: 20,
            justifyContent: "center",
          }}
        >
          {!isKyc && !!showError ? (
            <div style={{ padding: 10 }}>
              No Investor PAN found. Please submit Investor PAN
            </div>
          ) : (
            <React.Fragment>
              {!!display ? (
                <CustomLoader display={!!display} />
              ) : (
                <div
                  className="digital-form-Right-div responsive-history-detail"
                  style={{ borderLeft: 0 }}
                >
                  <SingleAmcheader investorData={investorData} />
                  <div className="transaction-list-name">
                    List of Transactions
                  </div>
                  {!!transactions && transactions.length > 0 ? (
                    <div>
                      {transactions.map((transaction, index) => (
                        <React.Fragment key={index}>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              marginTop: 5,
                            }}
                            className="history-detail-div"
                          >
                            <div className="investor-investments-container-title">
                              {transaction.SchemeDesc}
                            </div>
                            {transaction.Status === "Rejected" ? (
                              <Debtbutton
                                buttontitle="Reinitiate"
                                onClick={() =>
                                  this.props.history.push(
                                    NEW_TRANSACTION_URL + "/transction-types"
                                  )
                                }
                              />
                            ) : (
                              <div
                                className="transaction-button"
                                onClick={() =>
                                  this.props.history.push(
                                    NEW_TRANSACTION_URL + "/transction-types"
                                  )
                                }
                              >
                                <Image
                                  src={"/images/rupees_white.png"}
                                  className="transction-action-icon"
                                  alt="rupees-icon"
                                />
                                <span>New Transaction</span>
                              </div>
                            )}
                          </div>
                          {/* <div>{transaction.TrtypeDesc}</div>
                  <div
                    style={{
                      fontSize: 15,
                      fontFamily: "Rubik",
                      color: "#0076cb",
                    }}
                  >
                    Amount -{" "}
                    <FormatCurrency value={transaction.td_amt.split(".")[0]} />
                  </div> */}
                          <div className="investor-investments-sub-container">
                            <div className="define-width type-transact">
                              <div className="investor-investments-text">
                                Type
                              </div>
                              <div className="investor-investments-sub-text">
                                {transaction.TrtypeDesc}
                              </div>
                            </div>
                            <div className="define-width">
                              <div className="investor-investments-text">
                                Ref No
                              </div>
                              <div className="investor-investments-sub-text">
                                {transaction.td_trno}
                              </div>
                            </div>
                            <div className="define-width">
                              <div className="investor-investments-text">
                                Amount
                              </div>
                              <div className="investor-investments-sub-text">
                                <FormatCurrency
                                  value={transaction.td_amt.split(".")[0]}
                                />
                              </div>
                            </div>
                            <div className="define-width">
                              <div className="investor-investments-text">
                                Folio
                              </div>
                              <div className="investor-investments-sub-text">
                                {transaction.td_acno}
                              </div>
                            </div>
                            <div className="define-width">
                              <div className="investor-investments-text">
                                NAV
                              </div>
                              <div className="investor-investments-sub-text">
                                {/* <FormatCurrency value={transaction.td_nav} /> */}
                                {transaction.td_nav &&
                                transaction.td_nav !== "-"
                                  ? `${transaction.td_nav} (₹)`
                                  : "-"}
                              </div>
                            </div>
                            <div className="define-width">
                              <div className="investor-investments-text">
                                Units
                              </div>
                              <div className="investor-investments-sub-text">
                                {transaction.td_units}
                              </div>
                            </div>
                            <div className="define-width">
                              <div className="investor-investments-text">
                                Date
                              </div>
                              <div className="investor-investments-sub-text">
                                {transaction.td_trdt}
                              </div>
                            </div>
                            <div className="define-width">
                              <div className="investor-investments-text">
                                Status
                              </div>
                              <div
                                className="investor-investments-sub-text"
                                style={{
                                  color:
                                    transaction.Status === "Success"
                                      ? "#6fde7a"
                                      : "#e37474",
                                }}
                              >
                                {transaction.Status}
                              </div>
                            </div>
                          </div>
                        </React.Fragment>
                      ))}
                      {!!transactions && transactions.length > 0 && (
                        <div className="tran-history-note">
                          Note: For Historic Transaction Report, Please download
                          Transaction report from{" "}
                          <div
                            onClick={() =>
                              this.props.history.push({
                                pathname: `/mailBackRequest`,
                                state: {
                                  value: {
                                    KDM_Repcode: "MFSD201",
                                    KDM_Repdesc: "MFSD201 - Transaction Report",
                                  },
                                },
                              })
                            }
                            style={{
                              textDecoration: "underline",
                              cursor: "pointer",
                            }}
                          >
                            Mailback section
                          </div>
                        </div>
                      )}
                    </div>
                  ) : (
                    <div
                      style={{
                        fontFamily: "Rubik-Regular",
                        fontSize: 16,
                        textAlign: "center",
                        marginTop: 100,
                        color: "Red",
                      }}
                    >
                      {this.state.errorText}
                    </div>
                  )}
                </div>
              )}
            </React.Fragment>
          )}

          <div className="mobile-aum-list">
            <SingleAmcheader
              investorData={investorData}
              style={{ borderLeft: 0 }}
            />
            <div className="heading">
              Transactions<span>(Last 10 Transactions)</span>
            </div>
            {transactions.length > 0 ? (
              transactions.map((transaction, index) => (
                <InvestorTableCard
                  key={index}
                  Name={transaction.SchemeDesc}
                  history={this.props.history}
                  Type={transaction.TrtypeDesc}
                  Ref_No={transaction.td_trno}
                  Folio={transaction.td_acno}
                  Units={transaction.td_units}
                  Date={transaction.td_trdt}
                  Status={transaction.Status}
                  Amount={transaction.td_amt}
                  NAV={transaction.td_nav}
                  transaction={transaction}
                  transactions={this.props.transactions}
                />
              ))
            ) : (
              <div
                style={{
                  fontFamily: "SourceSansPro-SemiBold",
                  fontSize: 14,
                  textAlign: "center",
                  color: "red",
                }}
              >
                {" "}
                No Data Found
              </div>
            )}
          </div>
        </Paper>
        {!!transactions && transactions.length > 0 && (
          <div className="tran-history-note tran-history-note-responsive">
            Note: For Historic Transaction Report, Please download Transaction
            report from{" "}
            <div
              onClick={() =>
                this.props.history.push({
                  pathname: `/mailBackRequest`,
                  state: {
                    value: {
                      KDM_Repcode: "MFSD201",
                      KDM_Repdesc: "MFSD201 - Transaction Report",
                    },
                  },
                })
              }
              style={{ textDecoration: "underline", cursor: "pointer" }}
            >
              Mailback section
            </div>
          </div>
        )}
      </>
    );
  }
}

export default connect(
  ({ authReducer, transactionHistory }) => {
    const { investorData, userId } = authReducer;
    const { fundsList, transactions } = transactionHistory;
    return { investorData, userId, fundsList, transactions };
  },
  { getFundsByPan, getTransactionHistory, RemoveTransactionData }
)(HistoryDetail);

export class SingleAmcheader extends Component {
  render() {
    const { invname, PAN } = this.props.investorData;
    return (
      <div className="single-amc-header">
        <div className="content">
          <div>
            <Image
              src={"/images/user.png"}
              alt="user_icon"
              style={{ height: 48 }}
            />
          </div>
          <div style={{ marginLeft: 20 }} className="right-side">
            <div className="name">{invname}</div>
            <div className="pan">PAN - {PAN}</div>
          </div>
        </div>
      </div>
    );
  }
}
export class InvestorTableCard extends Component {
  render() {
    const {
      Type,
      Ref_No,
      Folio,
      Units,
      Date,
      Status,
      Amount,
      NAV,
      Name,
      Investordata,
      transactions,
    } = this.props;
    return (
      <div>
        <div
          style={{
            background: "white",
            border: "1px solid rgba(211,211,211,0.3)",
            padding: "7px 10px",
            margin: "10px 0px",
          }}
        >
          <div
            style={{
              fontFamily: "Rubik-Regular",
              color: "#005DAC",
              fontSize: 14,
              paddingBottom: 5,
              borderBottom: "1px solid rgba(211,211,211,0.3)",
            }}
          >
            {Name}
          </div>

          <div style={{ display: "flex", padding: "8px 0px" }}>
            <div style={{ flexGrow: 1, flexBasis: 0 }}>
              <div
                style={{
                  fontFamily: "Rubik-Regular",
                  fontSize: 12,
                  color: "#919191",
                }}
              >
                Type
              </div>
              <div
                style={{
                  fontFamily: "Rubik-Regular",
                  fontSize: 13,
                  color: "#194b7e",
                }}
              >
                {!!Type ? Type : "-"}
              </div>
            </div>
            <div style={{ flexGrow: 1, flexBasis: 0 }}>
              <div
                style={{
                  fontFamily: "Rubik-Regular",
                  fontSize: 12,
                  color: "#919191",
                }}
              >
                Amount
              </div>
              <div
                style={{
                  fontFamily: "Rubik-Regular",
                  fontSize: 13,
                  color: "#194b7e",
                }}
              >
                ₹{!!Amount.split(".")[0] ? Amount.split(".")[0] : "-"}
              </div>
            </div>
          </div>
          <div style={{ display: "flex", padding: "8px 0px" }}>
            <div style={{ flexGrow: 1, flexBasis: 0 }}>
              <div
                style={{
                  fontFamily: "Rubik-Regular",
                  fontSize: 12,
                  color: "#919191",
                }}
              >
                Ref No
              </div>
              <div
                style={{
                  fontFamily: "Rubik-Regular",
                  fontSize: 13,
                  color: "#194b7e",
                }}
              >
                {!!Ref_No ? Ref_No : "-"}
              </div>
            </div>
            <div style={{ flexGrow: 1, flexBasis: 0 }}>
              <div
                style={{
                  fontFamily: "Rubik-Regular",
                  fontSize: 12,
                  color: "#919191",
                }}
              >
                Folio
              </div>
              <div
                style={{
                  fontFamily: "Rubik-Regular",
                  fontSize: 13,
                  color: "#194b7e",
                }}
              >
                {!!Folio ? Folio : "-"}
              </div>
            </div>
          </div>
          <div style={{ display: "flex", padding: "8px 0px" }}>
            <div style={{ flexGrow: 1, flexBasis: 0 }}>
              <div
                style={{
                  fontFamily: "Rubik-Regular",
                  fontSize: 12,
                  color: "#919191",
                }}
              >
                NAV
              </div>
              <div
                style={{
                  fontFamily: "Rubik-Regular",
                  fontSize: 13,
                  color: "#194b7e",
                }}
              >
                {!!NAV && NAV !== "-" ? `₹${NAV}` : "-"}
              </div>
            </div>
            <div style={{ flexGrow: 1, flexBasis: 0 }}>
              <div
                style={{
                  fontFamily: "Rubik-Regular",
                  fontSize: 12,
                  color: "#919191",
                }}
              >
                Units
              </div>
              <div
                style={{
                  fontFamily: "Rubik-Regular",
                  fontSize: 13,
                  color: "#194b7e",
                }}
              >
                {!!Units ? Units : "-"}
              </div>
            </div>
          </div>
          <div style={{ display: "flex", padding: "8px 0px" }}>
            <div style={{ flexGrow: 1, flexBasis: 0 }}>
              <div
                style={{
                  fontFamily: "Rubik-Regular",
                  fontSize: 12,
                  color: "#919191",
                }}
              >
                Date
              </div>
              <div
                style={{
                  fontFamily: "Rubik-Regular",
                  fontSize: 13,
                  color: "#194b7e",
                }}
              >
                {!!Date ? Date : "-"}
              </div>
            </div>
            <div style={{ flexGrow: 1, flexBasis: 0 }}>
              <div
                style={{
                  fontFamily: "Rubik-Regular",
                  fontSize: 12,
                  color: "#919191",
                }}
              >
                Status
              </div>
              <div
                style={{
                  fontFamily: "Rubik-Regular",
                  fontSize: 13,
                  color: Status === "Success" ? "#6fde7a" : "#e37474",
                }}
              >
                {!!Status ? Status : "-"}
              </div>
            </div>
          </div>
          <div style={{ display: "flex", justifyContent: "space-around" }}>
            {Status === "Rejected" ? (
              <Debtbutton
                buttontitle="Reinitiate"
                onClick={() =>
                  this.props.history.push(
                    NEW_TRANSACTION_URL + "/transction-types"
                  )
                }
              />
            ) : (
              <div
                className="transaction-button"
                onClick={() =>
                  this.props.history.push(
                    NEW_TRANSACTION_URL + "/transction-types"
                  )
                }
              >
                <Image
                  src={"/images/rupees_white.png"}
                  className="transction-action-icon"
                  alt="rupees-icon"
                />
                <span>New Transaction</span>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}
